import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function RequestSubmit() {
  const navigate = useNavigate();

  const [t] = useTranslation("global");

  return (
    <>
      <div>
        <main className="mt-20">
          <div className="container mx-auto p-4">
            <div className="grid grid-cols-1 gap-3">
              <div className="mx-auto">
                <img
                  src="./assets/paymentconditions/paymentsuccess.png"
                  alt="payment success"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 gap-3">
              <div className="mx-auto text-center md:text-left">
                <p className="font-extrabold mt-6 font-roboto text-center md:text-left">
                  {t("join_agent_created")}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 mt-5">
              <div className="m-auto">
                <button
                  type="button"
                  onClick={() => navigate("/")}
                  className="bg-background_steel_blue text-text_white hover:bg-gray-100 font-medium text-sm px-5 py-2.5 me-2 mb-2"
                >
                  {t("back_home_text")}
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
